module.exports = __webpack_public_path__ + "media/images/lightbox/loading-fa54e1a0b386f83fabb7bc6e62bafd2c.gif";